import React from "react";
import { Edit, useRecordContext, required, FormDataConsumer, FunctionField, SimpleForm, TextInput, Toolbar, ListButton, SaveButton } from "react-admin";

import { InfluencerStatusSelectInput, InfluencerRatingBasedSelectNewInput } from "../../UI/Input/SelectInput";

import Grid from "@material-ui/core/Grid";


const PageTitle = () => {
  const record = useRecordContext();
  return <span>Content Review task for {record ? `${record.profile_id}` : ''}</span>;
};
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};
const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="list" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);

const ContentReviewEdit = (props) => {

  return (
    <Edit title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm warnWhenUnsavedChanges toolbar={<FormToolbar />} redirect="list" defaultValues={{ action: "full" }}>
        <SanitizedGrid container spacing={3} fullWidth>
          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Profile ID" source="profile_id" fullWidth />
          </Grid>
          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Name" source="name" fullWidth />
          </Grid>
          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Rating" source="rating_count" fullWidth />
          </Grid>
        </SanitizedGrid>
        <SanitizedGrid container spacing={3} fullWidth>
          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Content Review Question One" source="contentreviewerquestionone" fullWidth />
          </Grid>

          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Content Review Question Two" source="contentreviewerquestiontwo" fullWidth />
          </Grid>
          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Content Review Question Three" source="contentreviewerquestionthree" fullWidth />
          </Grid>
        </SanitizedGrid>

        <SanitizedGrid container spacing={3} fullWidth>
          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Content Review Question Input One" source="contentreviewerquestioninputone" fullWidth />
          </Grid>

          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Content Review Question Input Two" source="contentreviewerquestioninputtwo" fullWidth />
          </Grid>
          <Grid item sm={12} lg={4}>
            <TextInput disabled label="Content Review Question Input Three" source="contentreviewerquestioninputthree" fullWidth />
          </Grid>
        </SanitizedGrid>
        <SanitizedGrid container spacing={3} fullWidth>


          <Grid item sm={12} lg={4}>
            <FunctionField source="status" label="Status" render={record => {
              if (record['status'] === 'Pending') {
                return (<InfluencerStatusSelectInput validate={required()} label="Status" fullWidth source="status" />)
              } else {
                return (<TextInput disabled fullWidth label="Current_status" source="status" />)
              }
            }} />
          </Grid>
          <Grid item sm={12} lg={4}>
            <FormDataConsumer>
              {({ formData, ...rest }) =>
                formData.status === "Reject" && (
                  <TextInput source="decline_reason" label="Reason" fullWidth validate={required()} />
                )
              }
            </FormDataConsumer>
            
          </Grid>
        </SanitizedGrid>

      </SimpleForm>
    </Edit>
  );
};

export default ContentReviewEdit;
